import PropTypes from 'prop-types'

import View from '../../components/bantrab/view'
import Header from '../../components/bantrab/courses/listing/header'
import List from '../../components/bantrab/courses/listing/list'
import Breadcrumb from '../../components/bantrab/blog/listing/breadcrumb'
import { getBaseViewInfo } from '../../components/bantrab/view/functions'
import { getPage, getCourses as getItems } from '../../api/bantrab'
import { COURSES_LIST_QUERY as ITEMS_LIST_QUERY } from '../../api/bantrab/queries'

import { PROVIDERS, LACHIRIPA_TYPES } from '../../components/bantrab/courses/constants'

const ITEMS_PER_PAGE = parseInt(process.env.NEXT_PUBLIC_BANTRAB_COURSES_PER_PAGE_ON_LISTING)

const INDEX_TYPE = 'courses.CoursesIndexPage'

async function getServerSideProps () {
  const { head, navbar, footer, raw } = await getBaseViewInfo()

  const indexPages = raw.rootChildrenPages.items.filter(page => page.meta.type === INDEX_TYPE)
  const indexPageId = indexPages[0].id

  let indexPage = await getPage(indexPageId, { fields: '*' })
  indexPage = await indexPage.json()

  let courses = await Promise.all(
    [
      ...PROVIDERS.filter(item => item !== 'lachiripa').map(
        provider => {
          return getItems({
            ...ITEMS_LIST_QUERY,
            limit: ITEMS_PER_PAGE,
            provider: provider,
            has_specialization: false
          })
        }
      ),
      ...LACHIRIPA_TYPES.map(
        type => {
          return getItems({
            ...ITEMS_LIST_QUERY,
            limit: ITEMS_PER_PAGE,
            provider: 'lachiripa',
            lachiripa_type: type,
            has_specialization: false
          })
        }
      )
    ]
  )

  courses = await Promise.all(
    courses.map(
      item => item.json()
    )
  )

  courses = [
    ...courses.filter((_, index) => index < 4).map(
      (item, index) => [PROVIDERS[index], item]
    ),
    ...courses.filter((_, index) => index > 3).map(
      (item, index) => [`lachiripa-${LACHIRIPA_TYPES[index]}`, item]
    )
  ]

  const body = [
    {
      type: 'header',
      value: {
        title: indexPage.headerTitle,
        titleHighlightedText: indexPage.headerTitleHighlightedText,
        text: indexPage.headerText,
        image: indexPage.headerImage
      }
    },
    {
      type: 'courses',
      value: {
        courses: Object.fromEntries(courses)
      }
    }
  ]

  return {
    props: {
      head,
      navbar,
      body,
      footer,
      integrationSettings: raw.siteInfo.crehanaintegrationsettings
    }
  }
}

const Home = ({ head, navbar, body, footer, integrationSettings }) => {
  return <View
    {...{ head, navbar, footer }}>
    {
      body.map((section, index) => {
        if (section.type === 'header') {
          return <Header
            key={index}
            id={section.type}
            order={index}
            {...section.value}
          />
        }
        if (section.type === 'courses') {
          return <List
            key={index}
            id={section.type}
            order={index}
            {...section.value}
            integrationSettings={integrationSettings} 
            parametro='crehana' />
        }
        return null
      })
    }
    <Breadcrumb />
  </View>
}

Home.propTypes = {
  head: PropTypes.object,
  navbar: PropTypes.object,
  body: PropTypes.array,
  footer: PropTypes.object,
  integrationSettings: PropTypes.object
}

export { getServerSideProps }
export default Home
